import React, {useCallback, useEffect} from "react";
import {Drawer, DrawerContent, DrawerOverlay} from "@chakra-ui/react";
import TranslationQCPanel from "./TranslationQCPanel.tsx";
import {usePreviewQC} from "../../context/usePreviewQC.ts";

interface TranslationQCDrawerProps {
  projectId: string | null;
  isOpen: boolean;
  onClose: () => void;
}

const TranslationQCDrawer: React.FC<TranslationQCDrawerProps> = ({projectId, isOpen, onClose}) => {
  const {resetSession} = usePreviewQC();
  const closeSession = useCallback(() => {
    resetSession();
    onClose();
  }, [onClose, resetSession]);

  useEffect(() => () => resetSession(), [resetSession]);

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={closeSession} blockScrollOnMount={false}>
      <DrawerOverlay />
      <DrawerContent p={0} maxW="32rem"><TranslationQCPanel projectId={projectId} onClose={closeSession} /></DrawerContent>
    </Drawer>
  );
};

export default TranslationQCDrawer;
